import { useEffect, useState } from "react";
import { AlertTriangle, Check } from "lucide-react";
import { api } from "../lib/api";

export const useGeocodePreview = (q) => {
  const [state, setState] = useState({ checking: false, result: null, notFound: false });
  useEffect(() => {
    const v = (q || "").trim();
    if (v.length < 2) { setState({ checking: false, result: null, notFound: false }); return; }
    setState({ checking: true, result: null, notFound: false });
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/geocode", { params: { q: v } });
        setState({ checking: false, result: data.found ? data : null, notFound: !data.found });
      } catch {
        setState({ checking: false, result: null, notFound: true });
      }
    }, 600);
    return () => clearTimeout(t);
  }, [q]);
  return state;
};

export const geocodeLabel = (geo) => {
  if (!geo.result) return null;
  const name = (geo.result.name || "").split(",")[0];
  const country = (geo.result.full_name || "").split(",").slice(-1)[0]?.trim();
  return country && !name.toLowerCase().includes(country.toLowerCase()) ? `${name}, ${country}` : name;
};

export const GeocodePreview = ({ value, geo, testId }) => {
  const v = (value || "").trim();
  if (v.length < 2) return null;
  if (geo.checking) return <p data-testid={`${testId}-checking`} className="text-xs text-muted-foreground animate-pulse">Plaats opzoeken...</p>;
  if (geo.result) {
    const country = (geo.result.full_name || "").split(",").slice(-1)[0]?.trim();
    return (
      <p data-testid={`${testId}-found`} className="text-xs flex items-start gap-1.5 text-[#2D6A4F]">
        <Check className="w-3.5 h-3.5 shrink-0 mt-px" strokeWidth={3} />
        <span>Gevonden: <strong>{(geo.result.name || "").split(",")[0]}</strong>{country && <span className="text-muted-foreground font-normal"> ({country})</span>} — klopt dit niet? Typ dan preciezer, bv. "Venetië, Italië"</span>
      </p>
    );
  }
  if (geo.notFound) return (
    <p data-testid={`${testId}-notfound`} className="text-xs flex items-center gap-1.5 text-red-600">
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" /> Niet gevonden — probeer "plaatsnaam, land"
    </p>
  );
  return null;
};
